import System from "../helper/system";
import produceClone from "../helper/produceClone";
/**
 * Ticket #  : 10919
 * Change #  : After order place encode special character and than convert atob and btoa
 * Change by : Pankaj
 * Date      : 05 May 2023
 */
const setAllToURL = (data = {}, key_name = 'go') => {
    data = produceClone(data);
    let l = getAllFromURL(key_name);
    l[key_name] = btoa(encodeURIComponent(JSON.stringify(data)));
    //This says that string is black-encoded
    if (l[key_name] === 'e30=') {
        delete l[key_name];
    }
    toURL(l)
};

const getAllFromURL = (key_name = 'go', l = false) => {
    if (!l) {
        l = System.getParams()
    }
    if (l[key_name] !== undefined && l[key_name]) {
        try {
            l[key_name] = JSON.parse(decodeURIComponent(atob(l[key_name])))
        } catch (e) {
            l[key_name] = {}
        }
    } else {
        l[key_name] = {}
    }
    return l;
};
const getSingleFromURL = (key_name = 'go') => {
    let r = getAllFromURL(key_name);
    if (r[key_name] !== undefined) {
        return r[key_name];
    }
    return false;
};
const toURL = (l) => {
    history.replaceState(null, null, "?" + $.param(l));
};

class urlStorage {
    static setItem(key, value) {
        setAllToURL(value, key);
        return getSingleFromURL(key)
    }

    static getItem(key) {
        return getSingleFromURL(key)
    }

    static removeItem(key) {
        let o = false;
        let l = System.getParams();
        if (l[key] !== undefined) {
            delete l[key];
            o = true;
        }
        toURL(l);
        return o;
    }
}

export default urlStorage;
